module.exports = __webpack_public_path__ + "static/media/hiso-bus-rental-menu-facebook.cbb9b56a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hiso-bus-rental-menu/hiso-bus-rental-menu-facebook.svg
// module id = 371
// module chunks = 57